/* eslint-disable import/no-unused-modules */
import AddIcon from '@mui/icons-material/Add'
import { styled } from '@mui/material'
import React, { useCallback } from 'react'

import { Box, ButtonBase, Link } from '../../../../components'

export interface EditToolbarProps {
  addItemCallback: () => void
  viewHistoryCallback: () => void
  title: string
}

export const EditToolbar = ({ addItemCallback, viewHistoryCallback, title }: EditToolbarProps) => {
  const handleAdd = useCallback(() => {
    addItemCallback()
  }, [addItemCallback])

  const handleViewHistory = useCallback(() => {
    viewHistoryCallback()
  }, [viewHistoryCallback])

  const StyledContainer = styled(Box)`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    position: relative;
    padding: 16px 24px 16px 26px;
    width: 95%;
  `
  const StyledBox = styled(Box)`
    display: flex;
    flex-direction: column;
  `

  return (
    <StyledContainer data-test-id="edit_toolbar-container">
      <StyledBox>
        <h2>{title}</h2>
        <Link data-test-id="view_history-button" onClick={() => handleViewHistory()}>
          View history
        </Link>
      </StyledBox>
      <ButtonBase data-test-id="edit_toolbar-add_button" onClick={() => handleAdd()}>
        <AddIcon />
      </ButtonBase>
    </StyledContainer>
  )
}
